import {GameView} from "./GameView";
import * as PIXI from "pixi.js";
import {Movie} from "../flump";
import {AbstractPixiRoot} from "../AbstractPixiRoot";
import {ViewUtils} from "../utils";
import {GameObject} from "./GameObject";
import {GameTween} from "./GameJuggler";

export class GameWaiter extends GameView {

  private _blackImage!:PIXI.Graphics;
  private _spinner!:Movie;
  private _isShowed = false;
  private _container!:PIXI.Container;
  private _spinnerTween!:GameTween;
  private _blackTween!:GameTween;

  constructor(root:AbstractPixiRoot, container:PIXI.Container) {
    super();
    this.root = root;
    this._container = container;
  }

  override destroy():void {
    super.destroy();
  }

  protected createSpinner(): Movie {
    return this.root.uiLib!.create("spinner") as Movie;
  }

  public show():void {
    if (this._isShowed || this.destroyed) {
      return;
    }

    this._isShowed = true;

    this._blackImage = ViewUtils.createRect(this.root.fixedStageWidth, this.root.fixedStageHeight, '0x000000');
    this._container.addChild(this._blackImage);

    this._spinner = this.createSpinner();
    this._spinner.interactive = false;
    ViewUtils.alignPivot(this._spinner);
    this._spinner.x = this.root.fixedStageWidth / 2;
    this._spinner.y = this.root.fixedStageHeight / 2;
    this._spinner.alpha = 0.01;
    this._spinner.scale.set(0.01);
    this._spinner.playLoop();
    this._container.addChild(this._spinner);

    this._spinnerTween = this.root.juggler.tween(this._spinner, 0.4, {
      alpha: 1,
      scale: {
        x:1, y: 1
      }
    }).delay(0.2).start();

    this._blackTween = this.root.juggler.tween(this._blackImage, 0.4, {
      alpha: 0.4
    }).start();
  }

  public hide():void {
    if (this._isShowed) {
      this._spinnerTween?.destroy();
      this._blackTween?.destroy();
      GameObject.destroy(this._spinner);
      GameObject.destroy(this._blackImage);
      this._isShowed = false;
    }
  }
}
